// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/search.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    box-sizing: border-box;
    font-family: 'Roboto', sans-serif;
}

body {
    margin: 0;
    padding: 0;
    background: #F8F8F8;
    color: #333;
}

h1,
h2,
th {
    letter-spacing: 0.05em;
}

h1{
    font-size: 1.3em;
}

h2 {
    font-weight: 300;
}

table {
    width: 100%;
}

thead {
    background: #EEE;
    color: #444;
}

tbody tr:nth-child(even) {
    background: #F8F8F8;
}

th,
td {
    padding: 5px 10px;
    text-align: left;
    border-bottom: 1px solid #ddd;
}

th:last-child, td:last-child {
    width: 1%;
    white-space: nowrap;
}

td a {
    margin-right: 1rem;
    color: var(--link-color);
    text-decoration: none;
    transition: 0.5s all;
    line-height: 0.2;
    -webkit-user-select: none;
            user-select: none;
}

tbody tr:hover {
    background-color: #F8F8F8;
}

.container {
    padding: 30px 20px;
    background-color: #fff;
    border-radius: 8px;
    width:100%;
    max-width: unset;
    box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.1);
}

.container .empty{
    height: 350px;
    text-align: center;
    padding-top: 50px;
}

.btn {
    text-decoration: none;
    color: #fff;
    /* Changing text color to White */
    background-color: var(--button-background-color);
    border-radius: 20px;
    padding: 3px 15px;
    transition: 0.5s;
    font-family: 'Roboto', sans-serif;
    font-weight: 300;
    white-space: nowrap;
}

.btn.cancel{
    color: #444;
    background-color: #eee;
}

.btn:hover {
    background-color: var(--button-hover);
}

.table-header > * {
    margin-bottom: 15px;
}

.table-header h2{
    font-size: 0.8em;
}

.table-header .controls {
    display: flex;
}

.table-header .controls .btn {
    min-height: 22px;
    font-size: 0.8em;
}

.table-header .controls .search {
    width:100%;
    margin-right: 10px;
    position: relative;
}

.table-header .controls .search input{
    position: relative;
}

.table-header .controls .search::before {
    content: "";
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: 17px;
    position: absolute;
    top: 6px;
    left: 7px;
    width: 20px;
    height: 20px;
    opacity: 0.25;
    z-index: 2;
    background-repeat: no-repeat;
}

.table-header .controls .search input[type="text"] {
    padding: 2px 15px 2px 28px;
    border-radius: 25px;
    width: 100%;
    border: 1px solid #ddd;
}

.tabs{
    display: flex;
    justify-content: space-between;
    align-items: center;

}

.tabs a {
    background-color: #EEE;
    color: #444;
    padding: 10px 20px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    text-decoration: none;
    transition: 0.5s all;
    margin-right: 1rem;
}

.pagination ul {
    display: flex;
    padding: 8px 0;
    margin: 0.1em 0;
    justify-content: center;
}

/* .pagination ul li {
    margin:0 2px;
    font-size: 0.9em;
}

.pagination li.selected a{
    background-color: #ccc;
} */

.pagination ul li.previous a, .pagination ul li.next a {
    padding: 7px 6px 7px 8px;
    line-height: 20px;
    font-size: 0.6em;
}

.pagination a,
.tabs a,
.search button {
    background-color: #EEE;
    color: #444;
    padding: 7px;
    border-radius: 27px;
    text-decoration: none;
    transition: 0.5s all;
    white-space: nowrap;
    overflow: hidden;
    min-width: 35px;
    display: inline-block;
    text-align: center;
    -webkit-user-select: none;
            user-select: none;
}

.tabs {
    float: left;
}

.tabs a {
    padding: 10px 20px;
    text-decoration: none;
    transition: 0.5s all;
}

.tabs a.active {
    background-color: #DDD;
    color: #444;
}

.tabs a:hover {
    background-color: #DDD;
}

.pagination a:hover,
.tabs a:hover,
.search button:hover {
    background-color: #DDD;
}

.dialog {
    position: fixed;
    z-index: 1;
    padding-top: 100px;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0, 0, 0, 0.4);
}

.dialog-content {
    background: #fff;
    margin: auto;
    padding: 20px;
    border-radius: 4px;
    max-width: 500px;
}

.dialog-content > *{
    margin-bottom: 15px;
}

.dialog-content .dialog-buttons{
    margin-bottom: 0;
    text-align: right;
}

.dialog-content .dialog-buttons > *{
    margin-left:10px;
}`, "",{"version":3,"sources":["webpack://./src/components/ObjectList.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,iCAAiC;AACrC;;AAEA;IACI,SAAS;IACT,UAAU;IACV,mBAAmB;IACnB,WAAW;AACf;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,iBAAiB;IACjB,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,qBAAqB;IACrB,oBAAoB;IACpB,gBAAgB;IAChB,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,+CAA+C;AACnD;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,iCAAiC;IACjC,gDAAgD;IAChD,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,iCAAiC;IACjC,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,yDAAgD;IAChD,qBAAqB;IACrB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,aAAa;IACb,UAAU;IACV,4BAA4B;AAChC;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;;AAEvB;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,4BAA4B;IAC5B,6BAA6B;IAC7B,qBAAqB;IACrB,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,eAAe;IACf,uBAAuB;AAC3B;;AAEA;;;;;;;GAOG;;AAEH;IACI,wBAAwB;IACxB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;;;IAGI,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,qBAAqB;IACrB,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,qBAAqB;IACrB,kBAAkB;IAClB,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,UAAU;IACV,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;IACZ,cAAc;IACd,oCAAoC;AACxC;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":["* {\n    box-sizing: border-box;\n    font-family: 'Roboto', sans-serif;\n}\n\nbody {\n    margin: 0;\n    padding: 0;\n    background: #F8F8F8;\n    color: #333;\n}\n\nh1,\nh2,\nth {\n    letter-spacing: 0.05em;\n}\n\nh1{\n    font-size: 1.3em;\n}\n\nh2 {\n    font-weight: 300;\n}\n\ntable {\n    width: 100%;\n}\n\nthead {\n    background: #EEE;\n    color: #444;\n}\n\ntbody tr:nth-child(even) {\n    background: #F8F8F8;\n}\n\nth,\ntd {\n    padding: 5px 10px;\n    text-align: left;\n    border-bottom: 1px solid #ddd;\n}\n\nth:last-child, td:last-child {\n    width: 1%;\n    white-space: nowrap;\n}\n\ntd a {\n    margin-right: 1rem;\n    color: var(--link-color);\n    text-decoration: none;\n    transition: 0.5s all;\n    line-height: 0.2;\n    user-select: none;\n}\n\ntbody tr:hover {\n    background-color: #F8F8F8;\n}\n\n.container {\n    padding: 30px 20px;\n    background-color: #fff;\n    border-radius: 8px;\n    width:100%;\n    max-width: unset;\n    box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.1);\n}\n\n.container .empty{\n    height: 350px;\n    text-align: center;\n    padding-top: 50px;\n}\n\n.btn {\n    text-decoration: none;\n    color: #fff;\n    /* Changing text color to White */\n    background-color: var(--button-background-color);\n    border-radius: 20px;\n    padding: 3px 15px;\n    transition: 0.5s;\n    font-family: 'Roboto', sans-serif;\n    font-weight: 300;\n    white-space: nowrap;\n}\n\n.btn.cancel{\n    color: #444;\n    background-color: #eee;\n}\n\n.btn:hover {\n    background-color: var(--button-hover);\n}\n\n.table-header > * {\n    margin-bottom: 15px;\n}\n\n.table-header h2{\n    font-size: 0.8em;\n}\n\n.table-header .controls {\n    display: flex;\n}\n\n.table-header .controls .btn {\n    min-height: 22px;\n    font-size: 0.8em;\n}\n\n.table-header .controls .search {\n    width:100%;\n    margin-right: 10px;\n    position: relative;\n}\n\n.table-header .controls .search input{\n    position: relative;\n}\n\n.table-header .controls .search::before {\n    content: \"\";\n    background-image: url(\"../../public/search.png\");\n    background-size: 17px;\n    position: absolute;\n    top: 6px;\n    left: 7px;\n    width: 20px;\n    height: 20px;\n    opacity: 0.25;\n    z-index: 2;\n    background-repeat: no-repeat;\n}\n\n.table-header .controls .search input[type=\"text\"] {\n    padding: 2px 15px 2px 28px;\n    border-radius: 25px;\n    width: 100%;\n    border: 1px solid #ddd;\n}\n\n.tabs{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n}\n\n.tabs a {\n    background-color: #EEE;\n    color: #444;\n    padding: 10px 20px;\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n    text-decoration: none;\n    transition: 0.5s all;\n    margin-right: 1rem;\n}\n\n.pagination ul {\n    display: flex;\n    padding: 8px 0;\n    margin: 0.1em 0;\n    justify-content: center;\n}\n\n/* .pagination ul li {\n    margin:0 2px;\n    font-size: 0.9em;\n}\n\n.pagination li.selected a{\n    background-color: #ccc;\n} */\n\n.pagination ul li.previous a, .pagination ul li.next a {\n    padding: 7px 6px 7px 8px;\n    line-height: 20px;\n    font-size: 0.6em;\n}\n\n.pagination a,\n.tabs a,\n.search button {\n    background-color: #EEE;\n    color: #444;\n    padding: 7px;\n    border-radius: 27px;\n    text-decoration: none;\n    transition: 0.5s all;\n    white-space: nowrap;\n    overflow: hidden;\n    min-width: 35px;\n    display: inline-block;\n    text-align: center;\n    user-select: none;\n}\n\n.tabs {\n    float: left;\n}\n\n.tabs a {\n    padding: 10px 20px;\n    text-decoration: none;\n    transition: 0.5s all;\n}\n\n.tabs a.active {\n    background-color: #DDD;\n    color: #444;\n}\n\n.tabs a:hover {\n    background-color: #DDD;\n}\n\n.pagination a:hover,\n.tabs a:hover,\n.search button:hover {\n    background-color: #DDD;\n}\n\n.dialog {\n    position: fixed;\n    z-index: 1;\n    padding-top: 100px;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    overflow: auto;\n    background-color: rgba(0, 0, 0, 0.4);\n}\n\n.dialog-content {\n    background: #fff;\n    margin: auto;\n    padding: 20px;\n    border-radius: 4px;\n    max-width: 500px;\n}\n\n.dialog-content > *{\n    margin-bottom: 15px;\n}\n\n.dialog-content .dialog-buttons{\n    margin-bottom: 0;\n    text-align: right;\n}\n\n.dialog-content .dialog-buttons > *{\n    margin-left:10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
